import { reactive } from 'vue';

export function useLoader() {
  const state = reactive({ loading: false, finished: false });
  function startLoading() {
    state.loading = true;
    state.finished = false;
  }

  function endLoading() {
    state.finished = true;
    state.loading = false;
  }

  function reset() {
    state.loading = false;
    state.finished = false;
  }

  const wrapPromiseFnAndExecute = function <T>(promiseFn: () => Promise<T>): Promise<T> {
    return wrapPromiseFn(promiseFn)();
  };

  const wrapPromiseFn = function <T>(promiseFn: () => Promise<T>): () => Promise<T> {
    return () =>
      new Promise((resolve, reject) => {
        Promise.resolve(startLoading())
          .then(() => promiseFn())
          .then((res) => {
            resolve(res);
          })
          .catch((err: Error) => {
            reject(err);
          })
          .finally(() => {
            endLoading();
          });
      });
  };
  return { state, wrapPromiseFn, wrapPromiseFnAndExecute, startLoading, endLoading, reset };
}
